export default __webpack_public_path__ + "static/media/house.dbe7921f.jpg";